import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from "react-router-dom";
import FallbackComponent from "./FallbackComponent"

const FrontEndExpertSearch = lazy(() => import("../pages/front-end/search/expert"));
const FrontEndTaskSearch = lazy(() => import("../pages/front-end/search/task"));
const PrivacyPolicy = lazy(() => import("../pages/front-end/privacy-policy"));
const AboutUs = lazy(() => import("../pages/front-end/about-us"));
const ContactUs = lazy(() => import("../pages/front-end/contact-us"));
const Pricing = lazy(() => import("../pages/front-end/pricing"));
const Terms = lazy(() => import("../pages/front-end/terms-condition"));
const Refund = lazy(() => import("../pages/front-end/refund-policy"));
const BlogList = lazy(() => import("../pages/front-end/blog/BlogList"));
const SingleBlog = lazy(() => import("../pages/front-end/blog/single-blog"));
const ResetPassword = lazy(() => import("../pages/resetPassword"));
const AdminLoginPage = lazy(() => import("../pages/AdminLoginPage"));
const InternalLogin = lazy(() => import("../pages/InternalLogin"));
const ReferralGenerator = lazy(() => import("../pages/front-end/referral/ReferralGenerator"));
const TalentMarketplace = lazy(() => import("../pages/front-end/talent-marketplace"));
const Profile = lazy(() => import("../pages/common/profile"));
const PostNewTask = lazy(() => import("../pages/common/post-a-task/HomePostNewTask"));
const TaskPostedPage = lazy(() => import("../pages/TaskPostedPage"));

const FrontendAdminPath = () => {
    return (
        <Routes>
            <Route path="*" element={<Navigate replace to={`/not-found`} />} />
            <Route
                exact
                path="blogs"
                element={<Suspense fallback={<FallbackComponent />}><BlogList /></Suspense>}
            />

            <Route
                exact
                path="find-an-expert"
                element={<Suspense fallback={<FallbackComponent />}><FrontEndExpertSearch /></Suspense>}
            />

            <Route
                exact
                path="find-an-expert/:subjectName"
                element={<Suspense fallback={<FallbackComponent />}><FrontEndExpertSearch /></Suspense>}
            />

            <Route
                exact
                path="find-a-task"
                element={<Suspense fallback={<FallbackComponent />}><FrontEndTaskSearch /></Suspense>}
            />

            <Route
                exact
                path="expert-profile/:userKeyCode"
                element={<Suspense fallback={<FallbackComponent />}><Profile /></Suspense>}
            />

            <Route
                exact
                path="post-a-task"
                element={<Suspense fallback={<FallbackComponent />}><PostNewTask /></Suspense>}
            />

            <Route
                exact
                path="task-posted"
                element={<Suspense fallback={<FallbackComponent />}><TaskPostedPage /></Suspense>}
            />

            <Route
                path="task-posted/:orderId"
                element={<Suspense fallback={<FallbackComponent />}><TaskPostedPage /></Suspense>}
            />

            <Route
                exact
                path="admin-login"
                element={<Suspense fallback={<FallbackComponent />}><AdminLoginPage /></Suspense>}
            />
            <Route
                exact
                path="internal-login"
                element={<Suspense fallback={<FallbackComponent />}><InternalLogin /></Suspense>}
            />

            <Route
                exact
                path="privacy-policy"
                element={<Suspense fallback={<FallbackComponent />}><PrivacyPolicy /></Suspense>}
            />

            <Route
                exact
                path="about-us"
                element={<Suspense fallback={<FallbackComponent />}><AboutUs /></Suspense>}
            />

            <Route
                exact
                path="contact-us"
                element={<Suspense fallback={<FallbackComponent />}><ContactUs /></Suspense>}
            />

            <Route
                exact
                path="pricing"
                element={<Suspense fallback={<FallbackComponent />}><Pricing /></Suspense>}
            />

            <Route
                exact
                path="terms"
                element={<Suspense fallback={<FallbackComponent />}><Terms /></Suspense>}
            />

            <Route
                exact
                path="refund-policy"
                element={<Suspense fallback={<FallbackComponent />}><Refund /></Suspense>}
            />

            <Route
                exact
                path="referral-link"
                element={<Suspense fallback={<FallbackComponent />}><ReferralGenerator /></Suspense>}
            />

            <Route
                exact
                path="blogs/:url"
                element={<Suspense fallback={<FallbackComponent />}><SingleBlog /></Suspense>}
            />

            <Route
                exact
                path="reset-password"
                element={<Suspense fallback={<FallbackComponent />}><ResetPassword /></Suspense>}
            />

            <Route
                exact
                path="talent-nest"
                element={<Suspense fallback={<FallbackComponent />}><TalentMarketplace /></Suspense>}
            />

        </Routes>
    );
}

export default FrontendAdminPath;
